// src/services/imageService.js
import api from "./apiService";

/**
 * Upload a profile image for the current user
 * 
 * @param {File} imageFile - The image file to upload
 * @param {string} csrfToken - CSRF token for security (not used directly anymore)
 * @returns {Promise<{image_url: string}>} - Promise resolving to the uploaded image URL
 */
export const uploadProfileImage = async (imageFile, csrfToken) => {
  try {
    const formData = new FormData();
    formData.append('profile_image', imageFile);
    
    
    // Use the api instance from apiService.js
    // This will use the correct base URL and handle CSRF tokens
    const response = await api.post('/profile/upload-image', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Fix image URL to work with the backend
 * 
 * @param {string} url - The image URL from the server
 * @returns {string|null} - The fixed image URL or null if not available
 */
export const fixImageUrl = (url) => {
  if (!url) {
    return null;
  }
  
  // For debugging
  
  // If it's already an absolute URL, return it
  if (url.startsWith('http')) {
    return url;
  }
  
  // In development environment, prepend the API server URL
  if (process.env.NODE_ENV === 'development') {
    const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000';
    
    // Ensure the URL has a leading slash
    const formattedUrl = url.startsWith('/') ? url : `/${url}`;
    
    return `${apiUrl}${formattedUrl}`;
  }
  
  // In production, we can use the URL as is
  return url;
};